import type { ForAttentionStatusTranslation } from '@/features/execute-calculation-set/overmind/calculation/AttentionStatusTranslator';
import { AttentionStatusTranslator } from '@/features/execute-calculation-set/overmind/calculation/AttentionStatusTranslator';
import type { GridElementType } from '@/features/execute-calculation-set/overmind/calculation/derived-state/evaluatedGridElements/GridElement';

import type { HighlightedElements } from '../../components/Calculation/utils/styleMapElement';

export class HighlightedGridElements {
  private constructor(
    private readonly elements: GridElementType[],
    private readonly translator: ForAttentionStatusTranslation
  ) {}

  static from(elements: GridElementType[]) {
    return new HighlightedGridElements(
      elements,
      AttentionStatusTranslator.default()
    );
  }

  toRecord() {
    return this.elements.reduce<HighlightedElements>(
      (gridElementStatuses, gridElement) => {
        gridElementStatuses[gridElement.id] = this.translator.translate(
          gridElement.status
        );
        return gridElementStatuses;
      },
      {}
    );
  }
}
